import React, { FC, ReactNode, useEffect, useState } from "react";
import { ToastPosition, ToastVariant } from "common/enums/controls/toast.enum";
import "./ToastMessage.scss";
import { Toast } from "./toast/toast";

interface ToastMessageProps {
  variant: ToastVariant; //Controls which icon displays, color of icon, and the background color.
  position?: ToastPosition; //Positions the component to be position: fixed either at the top or bottom of the window.
  duration?: number; //Accepts a number for milliseconds
  children?: ReactNode;
  onClose?: () => void;
  type?: "filled" | "outlined" | "standard";
}
const ToastMessage: FC<ToastMessageProps> = ({
  variant = ToastVariant.INFO,
  position = ToastPosition.TOP,
  duration = 30000,
  children,
  onClose,
  type
}: ToastMessageProps) => {
  const [visible, setVisible] = useState<boolean>(true);

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  useEffect(() => {
    setTimeout(() => {
      handleClose();
    }, duration);
    setVisible(true);
  }, []);

  if (visible) {
    return (
      <Toast variant={variant} position={position} onClose={handleClose}>
        {children}
      </Toast>
    );
  } else return null;
};

export default ToastMessage;
